export default class PageComponentLoader {
    constructor(components) {
        this.components = components;
    }

    load() {
        let components = this.components;

        for (let selector in components) {
            $(selector).each(function () {
                let component = new components[selector](this);
                component.init();
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/utils/PageComponentLoader.js